import { Common } from './common';
import {
  SamlDomain,
  CreateValues as SamlDomainCreateValues,
} from './models/samlDomain';
import {
  SamlSetting,
  CreateValues as SamlSettingCreateValues,
  UpdateValues as SamlSettingUpdateValues,
} from './models/samlSetting';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async getOneById(id: string): Promise<SamlSetting> {
    const url = this.common.constructPath(`/saml-settings/${id}`);
    const { samlSetting } = await this.common.getJSON(url);
    return samlSetting;
  }

  async getDomainsBySamlSettingId(
    samlSettingId: string,
  ): Promise<SamlDomain[]> {
    const url = this.common.constructPath(
      `/saml-settings/${samlSettingId}/saml-domains`,
    );
    const { samlDomains } = await this.common.getJSON(url);
    return samlDomains;
  }

  async create(setting: SamlSettingCreateValues): Promise<SamlSetting> {
    const url = this.common.constructPath('/saml-settings/');
    const { samlSetting } = await this.common.postJSON(url, setting);
    return samlSetting;
  }

  async update(
    id: string,
    setting: SamlSettingUpdateValues,
  ): Promise<SamlSetting> {
    const url = this.common.constructPath(`/saml-settings/${id}`);
    const { samlSetting } = await this.common.patchJSON(url, setting);
    return samlSetting;
  }

  async remove(samlSettingId: string): Promise<boolean> {
    const url = this.common.constructPath(`/saml-settings/${samlSettingId}`);
    const { success } = await this.common.deleteJSON(url);
    return success;
  }

  async createDomain(domain: SamlDomainCreateValues): Promise<SamlDomain> {
    const url = this.common.constructPath('/saml-domains/');
    const { samlDomain } = await this.common.postJSON(url, domain);
    return samlDomain;
  }

  async removeDomain(samlDomainId: string): Promise<boolean> {
    const url = this.common.constructPath(`/saml-domains/${samlDomainId}`);
    const { success } = await this.common.deleteJSON(url);
    return success;
  }

  getMetadataUrl(slug: string): string {
    return this.common.constructPath(
      `/auth/saml/organizations/${slug}/metadata`,
    );
  }
}
